<template>
  <div class="container">
    <second-level>
      <div class="title">
        <h3 class="chinese">服务案例</h3>
        <div class="inner">
          <h3 class="english">Service Case</h3>
          <p class="line"></p>
        </div>
      </div>
    </second-level>
    <div class="inner">
      <div class="left">
        <short-video></short-video>
      </div>
      <div class="right">
        <case-search></case-search>
        <disease-case></disease-case>
      </div>
    </div>
  </div>
</template>

<script>
import SecondLevel from "../../SecondLevel";
import ShortVideo from "./ShortVideo";
import DiseaseCase from "./DiseaseCase";
import CaseSearch from "./CaseSearch";
export default {
  name: "Index",
  components: {
    SecondLevel,
    ShortVideo,
    CaseSearch,
    DiseaseCase
  }
};
</script>

<style lang="scss" scoped>
.container {
  /*display: flex;*/
  width: 75%;
  margin: 0 auto;
  .inner {
    display: flex;
  }
  .right {
    flex: 1;
  }
}
</style>
